import React from "react";
import { Container } from "react-bootstrap";


class Gloria extends React.Component {
  render() {
    return (
      <div className="Gloria">
        <header className="App-header">
          <h1>Torneo della Gloria</h1>
          <h5>(Organizzato da EOG#4417)</h5>
          <h5>Age of Empires IV</h5>
        </header>
        <header className="App-body">
          <Container>
            <iframe
              src={"https://docs.google.com/document/d/e/2PACX-1vSRvc5zSYvLqHoQf_TqJvgTlm-kiuiHcT9bUVHpw3njmM-LQm-_OicINNhQhWZgTEFyiW191whRu8v0/pub?embedded=true"}
              title="Torneo della Gloria"
              width="100%"
              height="600"
            ></iframe>
          </Container>
        </header>
      </div>
    );
  }
}

export default Gloria;
